var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconNotificationDocumentSelected(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.1875 12.3333H6.66667M11.625 1H1.70833C1.52047 1 1.3403 1.07463 1.20747 1.20747C1.07463 1.3403 1 1.52047 1 1.70833V14.4583C1 14.6462 1.07463 14.8264 1.20747 14.9592C1.3403 15.092 1.52047 15.1667 1.70833 15.1667H11.625C11.8129 15.1667 11.993 15.092 12.1259 14.9592C12.2587 14.8264 12.3333 14.6462 12.3333 14.4583V1.70833C12.3333 1.52047 12.2587 1.3403 12.1259 1.20747C11.993 1.07463 11.8129 1 11.625 1V1ZM4.1875 10.2083H9.14583H4.1875Z",
    stroke: "#0068F3",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotificationDocumentSelected);
export default __webpack_public_path__ + "static/media/icon_notification_document_selected.af140097a018d23802f67f30748d28e4.svg";
export { ForwardRef as ReactComponent };